import React from 'react';
import { DateTime } from 'luxon';
import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { MobileDatePicker } from '@mui/x-date-pickers';
import ImageField from '../fields/ImageField';
import HtmlField from '../fields/HtmlField';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';

const FieldInput = ({
  theme = 'light',
  maxRows = 10,
  minRows = 1,
  multiline = false,
  multiple = false,
  field,
  value,
  onChange,
  disabled,
  handleOpenDrawer,
  options = [],
}) => {
  const handleChipDelete = (deletedItemId) => {
    console.log('handleChipDelete', deletedItemId);

    const updatedItems = (value || []).filter(
      (item) => item._id !== deletedItemId?._id,
    );
    onChange(field.field, updatedItems); // Обновляем inputs
  };

  // const renderMultipleDrawerValue = (selectedItems, field) => (
  //   <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
  //     {selectedItems.map((item) => (
  //       <Chip
  //         key={item._id}
  //         label={item.title || item.name || item._id}
  //         size='small'
  //         onDelete={(e) => {
  //           e.stopPropagation();
  //           handleChipDelete(item); // ✅ Передаём ВЕСЬ объект
  //         }}
  //         onMouseDown={(e) => e.stopPropagation()}
  //       />
  //     ))}
  //   </Box>
  // );
  const renderMultipleDrawerValue = (selectedItems, field) => (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
      {selectedItems.map((item, index) => (
        <Chip
          key={item._id || index} // ✅ Добавили fallback на index
          label={item.title || item.name || item._id}
          size='small'
          onDelete={(e) => {
            e.stopPropagation();
            handleChipDelete(item);
          }}
          onMouseDown={(e) => e.stopPropagation()}
        />
      ))}
    </Box>
  );

  const handleTextChange = React.useCallback(
    (e) => {
      onChange(field.field, e.target.value);
    },
    [onChange, field.field], // зависимости — меняются редко
  );

  switch (field.type) {
    case 'image':
      return (
        <ImageField
          disabled={disabled}
          editable={field.editable}
          url={value}
          onChange={(file) => onChange(field.field, file)}
          label={field.label}
        />
      );
    case 'html':
      return (
        <HtmlField
          disabled={disabled}
          field={field}
          value={value}
          onChange={onChange}
          theme={theme}
        />
      );
    case 'checkbox':
      return (
        <FormControlLabel
          control={
            <Checkbox
              disabled={disabled}
              checked={value || false}
              onChange={(e) => onChange(field.field, e.target.checked)}
            />
          }
          label={field.label}
        />
      );
    case 'select':
      // console.log('select value', field.label, value);
      return (
        <FormControl fullWidth size='small' disabled={disabled}>
          <InputLabel>{field.label}</InputLabel>
          <Select
            value={value?._id || value || ''}
            label={field.label}
            onChange={(e) => {
              // Найти option по value
              const selectedOption = field.options?.find(
                (opt) => opt.value === e.target.value,
              );
              onChange(field.field, selectedOption || e.target.value);
            }}
          >
            {field.options?.map((option, index) => (
              <MenuItem key={option._id || index} value={option._id}>
                {option.title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    case 'drawer':
      if (!multiple) {
        return (
          <TextField
            disabled={disabled}
            fullWidth
            label={field.label}
            value={value || ''}
            size='small'
            onClick={() => {
              // console.log('clicked');
              if (!disabled) {
                handleOpenDrawer();
              }
            }}
            inputProps={{ readOnly: true }} // блокируем ручной ввод
          />
        );
      }
      //  MULTIPLE — Select с Chips (без нового компонента!)
      // console.log('multiple value', value);
      let displayValue = '';
      if (Array.isArray(value)) {
        displayValue = value;
      } else {
        displayValue = value ? [value] : [];
      }

      return (
        <FormControl fullWidth size='small' disabled={disabled}>
          <InputLabel>{field.label}</InputLabel>
          <Select
            multiple
            value={(displayValue || []).map((item) => item._id)} // ✅ IDs из реального массива
            onChange={() => {}} // Блокируем dropdown
            input={<OutlinedInput label={field.label} />}
            renderValue={(selectedIds) =>
              renderMultipleDrawerValue(
                displayValue || [],
                field,
                (updatedItems) => onChange(field.field, updatedItems), // ✅ Callback!
              )
            }
            onClick={() => {
              // console.log('clicked MULTIPLE');
              if (!disabled) {
                handleOpenDrawer();
              }
            }}
            inputProps={{ readOnly: true }}
            MenuProps={{ disablePortal: true }}
            sx={{ cursor: disabled ? 'default' : 'pointer' }}
          />
        </FormControl>
      );
    case 'date':
      return (
        <MobileDatePicker
          disabled={disabled}
          // autoOk={true}
          // disableCloseOnSelect={false}
          closeOnSelect={true}
          label={field.label}
          // disableFuture={true}
          // value={value || null}
          size='small'

          // Если value пустое, лучше передавать null, чтобы не было ошибок парсинга пустой строки
        value={value ? DateTime.fromISO(value) : null} 
        
        // ✅ ИСПРАВЛЕНО: передаем field.field первым аргументом, а дату вторым
        // onChange={(newDate) => onChange(field.field, newDate ? newDate.toISO() : null)}

        onChange={(newDate) => {
          if (!newDate) {
            onChange(field.field, null);
            return;
          }

          // Если это планируемая дата завершения (дедлайн) — ставим конец дня (23:59:59)
          if (field.field === 'dates.plannedEnd') {
            onChange(field.field, newDate.endOf('day').toISO());
          } 
          // Для любых других дат ставим ровно середину дня (12:00:00) 
          // Это гарантирует, что день не "уедет" во вчера или завтра ни в одном часовом поясе
          else {
            onChange(field.field, newDate.set({ hour: 12, minute: 0, second: 0, millisecond: 0 }).toISO());
          }
        }}

          // value={DateTime.fromISO(value)}
          // onChange={(value) => onChange(value.toISO())}
          sx={{ width: '100%' }}
          slotProps={{
            textField: {
              fullWidth: true,
              error: false, // красная обводка
              size: 'small',
              // helperText: !value ? 'Обязательное поле' : '',
            },
          }}
        />
      );
    case 'text':
      return (
        <TextField
          maxRows={multiline ? maxRows : 10}
          minRows={multiline ? minRows : 1}
          multiline={multiline}
          disabled={disabled}
          fullWidth
          label={field.label}
          value={value || ''}
          // onChange={(e) => onChange(field.field, e.target.value)}
          onChange={handleTextChange}
          size='small'
        />
      );
    case 'list':
      const sortedOptions = [
        ...options.filter((opt) =>
          value.includes(opt.value ?? opt._id ?? opt.id),
        ),
        ...options.filter(
          (opt) => !value.includes(opt.value ?? opt._id ?? opt.id),
        ),
      ];
      return (
        <Box
          sx={{
            border: '1px solid',
            borderColor: 'divider', // или 'primary.main', 'grey.400' и т.д.
            borderRadius: 1,
            p: 2,
            pt: 3, // дополнительный отступ сверху для заголовка
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          {/* Заголовок над рамкой */}
          <Typography
            variant='body2' // или "caption", "body2"
            sx={{
              position: 'absolute',
              top: 0,
              left: 5,
              // bgcolor: 'background.paper', // фон под текстом, чтобы перекрывал border
              px: 1,
              // fontWeight: 'medium',
              color: 'text.secondary',
            }}
          >
            {field.label || 'Выберите значения'}
          </Typography>
          <List
            sx={{
              width: '100%',
              // maxWidth: 360,
              // bgcolor: 'background.paper',
              position: 'relative',
              overflow: 'auto',
              maxHeight: 200,
              '& ul': { padding: 0 },
            }}
          >
            <ul>
              {sortedOptions.map((item, index) => {
                // Что использовать как уникальный идентификатор значения
                const itemValue = item.value ?? item._id ?? item.id ?? index;

                // Проверяем, выбран ли этот элемент
                const isChecked = value.includes(itemValue);

                return (
                  <ListItem
                    key={`list-item-${itemValue}-${index}`}
                    disablePadding
                    // Можно кликать по всей строке (удобнее пользователю)
                    onClick={() => {
                      if (disabled) return;
                      const newValue = isChecked
                        ? value.filter((v) => v !== itemValue) // убираем
                        : [...value, itemValue]; // добавляем

                      onChange(field.field, newValue);
                    }}
                    sx={{ cursor: 'pointer' }}
                  >
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      <Checkbox
                        edge='start'
                        checked={isChecked}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{
                          'aria-labelledby': `checkbox-list-label-${itemValue}`,
                        }}
                        // Предотвращаем двойное срабатывание при клике на чекбокс
                        onClick={(e) => e.stopPropagation()}
                      />
                    </ListItemIcon>

                    <ListItemText
                      id={`checkbox-list-label-${itemValue}`}
                      primary={
                        item.title ||
                        item.label ||
                        item.name ||
                        `Элемент ${index + 1}`
                      }
                      primaryTypographyProps={{ noWrap: true }}
                    />
                  </ListItem>
                );
              })}
            </ul>
          </List>
        </Box>
      );
    case 'phones':
      if (disabled) {
        const parsePhonesWithNames = (value) => {
          if (!value?.trim()) return [];

          let parts;
          if (value.includes(',')) parts = value.split(',');
          else if (value.includes(';')) parts = value.split(';');
          else if (value.includes('|')) parts = value.split('|');
          else parts = [value];

          const result = [];
          let contactCounter = 1;

          parts.forEach((part) => {
            const trimmed = part.trim();
            if (!trimmed) return;

            // ✅ ФИКС: ловим обе группы
            const bracketMatch = trimmed.match(/\[(.*?)\]|(?:\((.*?)\))/);
            const name =
              (bracketMatch?.[1] || bracketMatch?.[2])?.trim() ||
              `Контакт ${contactCounter++}`;

            // ЧИСТЫЙ номер
            const phoneMatches = trimmed.match(/[\d+]+/g);
            const cleanPhone = phoneMatches ? phoneMatches.join('') : '';

            if (cleanPhone) {
              result.push({ number: cleanPhone, name });
            }
          });

          return result;
        };

        const phones = parsePhonesWithNames(value);
        // console.log('phones', phones);

        const Callto = ({ phone, children }) => {
          return <a href={`tel:${phone}`}>{children}</a>;
        };
        return (
          <>
            {phones.map((phone, index) => {
              return (
                <Grid
                  key={`${phone?.number}-${index}`}
                  item
                  xs={12}
                  spacing={1}
                  container
                  sx={{ pb: 0, mb: 1 }}
                >
                  <Grid item xs={4}>
                    {phone.name ? phone.name : 'Контакт'}
                  </Grid>
                  <Grid item xs={8}>
                    <Callto phone={phone?.number}>
                      <Chip
                        icon={<LocalPhoneIcon />}
                        label={phone?.number}
                        variant='outlined'
                      />
                    </Callto>
                  </Grid>
                </Grid>
              );
            })}
          </>
        );
      } else {
        return (
          <TextField
            maxRows={multiline ? maxRows : 10}
            minRows={multiline ? minRows : 1}
            multiline={multiline}
            disabled={disabled}
            fullWidth
            label={field.label}
            value={value || ''}
            // onChange={(e) => onChange(field.field, e.target.value)}
            onChange={handleTextChange}
            size='small'
          />
        );
      }
    default:
      return (
        <TextField
          maxRows={multiline ? maxRows : 10}
          minRows={multiline ? minRows : 1}
          multiline={multiline}
          disabled={disabled}
          fullWidth
          label={field.label}
          value={value || ''}
          // onChange={(e) => onChange(field.field, e.target.value)}
          onChange={handleTextChange}
          size='small'
        />
      );
  }
};

export default FieldInput;
